export default __webpack_public_path__ + "static/media/icon-about.229d244e.png";